export function parseDsn(dsn: string): { url: string } {
  const url = new URL(dsn)

  const wsUrl = `${url.protocol}//${url.hostname}:${url.port ?? ''}/connection/websocket`

  return { url: wsUrl }
}
